export enum Sex {
  Unknown = 0,
  Male = 1,
  Female = 2,
}

export enum Risk {
  Unknown = -1,
  Optimal = 0,
  Normal = 1,
  Risk = 2,
  HighRisk = 3,
  ImmediateRisk = 4,
}

export type Unit =
  | "%"
  | "bmi"
  | "bpm"
  | "cm"
  | "g/L"
  | "mg/L"
  | "mmHg"
  | "mmol/L"
  | "mmol/mol"
  | "ratio"
  | "x10⁹/L"
  | "unknown";

export type Value<U extends Unit> = Record<U, number>;
